import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from "react-intl";
import { Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import { getI18n } from "../../../utils/intl";
import { getThemes, getCmsSettings } from '../../../reducers/portalConfig';

import { LABELS } from '../constants';
import { getThemeDetails, goToRegistrationPage } from "../utils";

const SignupButton = ({ classes }) => {
  const intl = getI18n(useIntl());

  const { REGISTRATION_STATUS, DISABLE_LOCAL_LOGINS } = useSelector(getCmsSettings);
  const themeData = useSelector(getThemes);
  const { logo, alternateLogo } = getThemeDetails(themeData);

  const isLocalLoginEnabled = DISABLE_LOCAL_LOGINS ? DISABLE_LOCAL_LOGINS === 'false' : true;
  const shouldShowSignupButton = REGISTRATION_STATUS === 'ENABLED' && isLocalLoginEnabled;
  return shouldShowSignupButton
    ? (
      <Button
        data-apim-test="login-signup-button"
        variant="outlined" color='secondary'
        startIcon={logo ? <img
          alt="Portal Logo"
          src={logo}
        /> : <Typography className={classes.alternateLogo} align='center'>
          {alternateLogo}
        </Typography>}
        classes={{
          root: classes.buttonStyles, startIcon: logo ? classes.buttonIcon : '',
        }}
        onClick={goToRegistrationPage}
      >
        <Typography className={classes.buttonContent} color='inherit'>
          {intl.getI18nMessage(LABELS.signupButton)}
        </Typography>
      </Button>
    ) : null
}

SignupButton.propTypes = {
  classes: PropTypes.shape(),
}

export default SignupButton;
